const PAYROLL_CLOSING_KEYS = {
	QUERY: {},
	MUTATION: {
		UPDATE_COMMISSION_CYCLE_TO_FINALIZING_PROCESS: "updateCommissionCycleToFinalizingProcess",
		UPDATE_COMMISSION_CYCLE_STATUS: "updateCommissionCycleStatus",
	},
	SUBSCRIPTION: {
		ON_UPDATE_COMMISSION_CYCLE_TO_FINALIZING_PROCESS: "onUpdateCommissionCycleToFinalizingProcess",
		ON_UPDATE_COMMISSION_CYCLE_STATUS: "onUpdateCommissionCycleStatus",
	},
};

export { PAYROLL_CLOSING_KEYS };
